<ndt-add-find-me-follow-me-step-view
   [callState]="callState | async"
   [form]="form"
   [extension]="extension"
   [title]="title"
   [accountId]="extension?.accountId"
   (formCanceled)="onCloseClick()"
   (formSubmitted)="onCreate()"
>
</ndt-add-find-me-follow-me-step-view>
